import PropTypes from 'prop-types';
import React from 'react';
import { cymbioColors } from '../../../utils/colors';

const strokeColor = cymbioColors.analytics.textSecondary;

export function ReportsWarehouseIcon({ color = strokeColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_0_946)">
        <path
          d="M2.5 17.5V6.66671L10 3.33337L17.5 6.66671V17.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8332 10.8333H14.1665V17.4999H5.83319V12.4999H10.8332"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8333 17.5V9.99996C10.8333 9.77895 10.7455 9.56698 10.5893 9.4107C10.433 9.25442 10.221 9.16663 10 9.16663H8.33333C8.11232 9.16663 7.90036 9.25442 7.74408 9.4107C7.5878 9.56698 7.5 9.77895 7.5 9.99996V12.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_946">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

ReportsWarehouseIcon.propTypes = {
  color: PropTypes.string,
};
